import { render, staticRenderFns } from "./FormInlineList.vue?vue&type=template&id=2c6ab890"
import script from "./FormInlineList.ts?vue&type=script&lang=ts"
export * from "./FormInlineList.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports